import React, { JSX } from 'react';
import { Box, Checkbox, TableCell, TableHead, TableRow } from '@mui/material';
import {
  Business as BusinessIcon,
  KeyboardArrowDown as ArrowDownIcon,
  KeyboardArrowUp as ArrowUpIcon,
  Schedule as ScheduleIcon,
  Work as WorkIcon,
} from '@mui/icons-material';
import { SortField, SortOrder } from './jobsViewUtils';

export function JobsViewTableHead(props: {
  isMobile: boolean;
  selectable: boolean;
  selectedCount: number;
  rowCount: number;
  showActions: boolean;
  sortField: SortField;
  sortOrder: SortOrder;
  onSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSort: (field: SortField) => void;
}): JSX.Element {
  return (
    <TableHead>
      <TableRow>
        {props.selectable && (
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={props.selectedCount > 0 && props.selectedCount < props.rowCount}
              checked={props.rowCount > 0 && props.selectedCount === props.rowCount}
              onChange={props.onSelectAll}
            />
          </TableCell>
        )}
        <HeaderCell
          field="company"
          label="Company"
          icon={<BusinessIcon fontSize="small" />}
          width={props.isMobile ? 'auto' : '80px'}
          {...props}
        />
        <HeaderCell
          field="title"
          label="Title"
          icon={<WorkIcon fontSize="small" />}
          width={props.isMobile ? 'auto' : '95px'}
          {...props}
        />
        <TableCell sx={{ width: props.isMobile ? 'auto' : '125px' }}>Description</TableCell>
        {!props.isMobile && <TableCell sx={{ width: '70px' }}>Pay Range</TableCell>}
        {!props.isMobile && <TableCell sx={{ width: '60px' }}>Owner</TableCell>}
        {!props.isMobile && (
          <HeaderCell
            field="updatedAt"
            label="Updated"
            icon={<ScheduleIcon fontSize="small" />}
            width="95px"
            {...props}
          />
        )}
        {!props.isMobile && <TableCell align="center" sx={{ width: '48px' }} />}
        {!props.isMobile && props.showActions && (
          <TableCell align="center" sx={{ width: '95px' }}>
            Actions
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

function HeaderCell(props: {
  field: SortField;
  label: string;
  icon: JSX.Element;
  width: string;
  sortField: SortField;
  sortOrder: SortOrder;
  onSort: (field: SortField) => void;
}): JSX.Element {
  return (
    <TableCell
      sx={{ cursor: 'pointer', width: props.width }}
      onClick={() => props.onSort(props.field)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {props.icon}
        {props.label} {getSortIcon(props.field, props.sortField, props.sortOrder)}
      </Box>
    </TableCell>
  );
}

function getSortIcon(field: SortField, sortField: SortField, sortOrder: SortOrder): JSX.Element {
  if (sortField !== field) return <></>;
  return sortOrder === 'asc' ? (
    <ArrowUpIcon fontSize="small" />
  ) : (
    <ArrowDownIcon fontSize="small" />
  );
}
